import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import * as Schema from 'src/types/graphql';

import type { ProfileInsightsActivity } from './types';

export const useGetProfileInsights = () => {
  const { locale, zone, language } = useAppConfig();
  const timezone =
    // eslint-disable-next-line new-cap
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Melbourne';
  const { data, loading, error } = useQuery(Schema.GetProfileInsightsDocument, {
    // TODO: use locale from melways
    variables: { zone, locale: `${language}-${locale}`, timezone },
  });

  const searchImpressionCount =
    data?.viewer?.profileInsights2?.searchImpressionCount ?? 0;
  const viewCount = data?.viewer?.profileInsights2?.viewCount ?? 0;
  const rawProfileInsights = data?.viewer?.profileInsights2;

  const profileInsights = rawProfileInsights
    ? {
        ...rawProfileInsights,
        activities: (rawProfileInsights.activities?.filter(
          (activity) =>
            activity.advertiser &&
            (activity.__typename !== 'ProfileInsightsJobSentActivity2' ||
              activity.job),
        ) ?? []) as ProfileInsightsActivity[],
      }
    : null;

  return {
    showProfileInsights: searchImpressionCount > 0 || viewCount > 0,
    profileInsights,
    loading,
    error,
  };
};
